import { OBJECTIVELINKED_SUCCESS, OBJECTIVELINKED_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const objectiveLinkedReducer = (state = initialState, action) => {
    switch (action.type) {
        case OBJECTIVELINKED_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case OBJECTIVELINKED_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }
    return state;
};

export default objectiveLinkedReducer;



